export default __webpack_public_path__ + "static/media/Roboto-Regular.19030d54.woff";